import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CustomComponent } from '@cakeiteasy/web-utils';
import { PAYMENT_PERSON_TYPES } from '../../payment.constants';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'choose-payment-person-type',
  templateUrl: './choose-payment-person-type.component.html',
  styleUrls: ['./choose-payment-person-type.component.scss']
})
export class ChoosePaymentPersonTypeComponent extends CustomComponent {
  @Input() showTitle = true;
  @Input() showAsRadio = false;

  public type: string;
  public PAYMENT_PERSON_TYPES = PAYMENT_PERSON_TYPES;
  public PAYMENT_PERSON_TYPE_OPTIONS: { id: string, label: string }[];

  @Input()
  public get personType() {
    return this.type;
  }

  public set personType(type: string) {
    const isChanged = this.type !== type;
    this.type = type;

    if (isChanged) {
      this.personTypeChange.emit(type);
    }
  }

  public get personTypeOption() {
    return this.PAYMENT_PERSON_TYPE_OPTIONS.find((p) => p.id === this.personType);
  }

  @Output() personTypeChange = new EventEmitter<string>();

  constructor(private _translateService: TranslateService) {
    super();

    this.PAYMENT_PERSON_TYPE_OPTIONS = [
      {
        label: this._translateService.instant('orderProcess.payment.choosePersonType.private'),
        id: PAYMENT_PERSON_TYPES.PRIVATE
      }, {
        label: this._translateService.instant('orderProcess.payment.choosePersonType.business'),
        id: PAYMENT_PERSON_TYPES.COMPANY
      }
    ];
  }
}
